module.exports = __webpack_public_path__ + "static/assets/b57d595b61ccf96a1089a0490ca5d175.svg";